<template>
  <div class="statistics-container">
    <div class="enterprise-container"><el-empty description="暂无数据"></el-empty></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'Statistics',
  data() {
    return {
      pieChartInstance: null,
      lineChartInstance: null,
      barChartInstance: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initPieChart()
      this.initLineChart()
      this.initBarChart()
    })
  },
  beforeDestroy() {
    if (this.pieChartInstance) this.pieChartInstance.dispose()
    if (this.lineChartInstance) this.lineChartInstance.dispose()
    if (this.barChartInstance) this.barChartInstance.dispose()
  },
  methods: {
    initPieChart() {
      this.pieChartInstance = echarts.init(this.$refs.pieChart)
      this.pieChartInstance.setOption({
        tooltip: { trigger: 'item' },
        legend: { bottom: '5%', left: 'center' },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          data: [
            { value: 148, name: '项目审批' },
            { value: 86, name: '项目核准' },
            { value: 120, name: '项目备案' },
            { value: 65, name: '节能审查' },
            { value: 92, name: '环境评价' }
          ]
        }]
      })
    },
    initLineChart() {
      this.lineChartInstance = echarts.init(this.$refs.lineChart)
      this.lineChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: ['1月', '2月', '3月', '4月', '5月', '6月'] },
        yAxis: { type: 'value' },
        series: [{
          data: [120, 200, 150, 80, 170, 230],
          type: 'line',
          smooth: true,
          areaStyle: { opacity: 0.3 }
        }]
      })
    },
    initBarChart() {
      this.barChartInstance = echarts.init(this.$refs.barChart)
      this.barChartInstance.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: { type: 'category', data: ['北京', '上海', '广州', '深圳', '杭州', '成都', '武汉', '西安'] },
        yAxis: { type: 'value' },
        series: [{
          data: [320, 280, 250, 220, 180, 160, 140, 120],
          type: 'bar',
          itemStyle: { color: '#1e3a5f' }
        }]
      })
    }
  }
}
</script>

<style scoped>
.statistics-container {
  padding: 0;
}

.chart-container {
  height: 300px;
}

.chart-container-large {
  height: 400px;
}
</style>
